import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Radio, RefreshCw } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/sports-betting`;
const REBUILD = { nfl: '/suggestions/rebuild', nba: '/nba/rebuild' };
const dur = (m) => (m == null ? '—' : m < 60 ? `${m}m` : m < 1440 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${Math.floor(m / 1440)}d`);
const ago = (m) => (m == null ? 'not yet' : m < 1 ? 'just now' : `${dur(Math.round(m))} ago`);

// Live freshness strip: how old the picks are and how fast they refresh as kickoff gets close.
export default function PregameStatus({ leagues = ['nfl', 'cfb', 'nba'] }) {
  const [st, setSt] = useState(null);
  const load = useCallback(() => axios.get(`${API}/pregame`).then((r) => setSt(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  const refresh = async (lg) => {
    try { await axios.post(`${API}${REBUILD[lg]}`); toast.success('Pulling the latest injuries, lines and news… about a minute'); setTimeout(load, 60000); } catch (_e) { toast.error('Refresh failed'); }
  };
  if (!st) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="pregame-status">
      {leagues.filter((lg) => st[lg]).map((lg) => {
        const s = st[lg]; const hot = s.cadence_min != null;
        return (
          <div key={lg} className={`flex items-center gap-2 rounded-lg border px-2.5 py-1.5 text-[11px] ${hot ? 'border-red-500/50 bg-red-950/30' : 'border-zinc-800 bg-zinc-900/60'}`} data-testid={`pregame-${lg}`}>
            {hot && <Radio className="w-3.5 h-3.5 text-red-400 animate-pulse" />}
            <span className="font-bold text-white">{s.league}</span>
            <span className="text-zinc-400">updated {ago(s.age_min)}{s.building ? ' · updating…' : ''}</span>
            {s.minutes_to_kickoff != null && <span className="text-zinc-400">· next kickoff {dur(s.minutes_to_kickoff)}</span>}
            {hot && <span className="font-semibold text-red-300">· Pregame mode: every {s.cadence_min} min</span>}
            {REBUILD[lg] && (
              <button type="button" onClick={() => refresh(lg)} title="Refresh now" data-testid={`pregame-refresh-${lg}`} className="text-zinc-400 hover:text-white">
                <RefreshCw className="w-3 h-3" />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
